export const SET_VALID_PHONE = 'SET_VALID_PHONE'
export const SET_VALID_PHONE_SUCCESS = 'SET_VALID_PHONE_SUCCESS'
export const SET_VALID_PHONE_ERROR = 'SET_VALID_PHONE_ERROR'

export const SetValidPhone = (data) => ({
  type: SET_VALID_PHONE,
  payload: data
})
